export default "__VITE_ASSET__e05b19a9__"